import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CUSTOM_ICON_TYPE } from '@shared/models';

@Component({
  selector: 'sd-manager-will-call',
  templateUrl: './manager-will-call.component.html',
  styleUrls: ['./manager-will-call.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorManagerWillCallComponent {
  iconType = CUSTOM_ICON_TYPE;
}
